import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(contractId, request) {
  return axios.post(
    api.path("contractCustomerDatabase.store", { contractId: contractId }),
    request
  );
}

export function update(contractId, id, request) {
  return axios.put(
    api.path("contractCustomerDatabase.update", {
      contractId: contractId,
      customerDatabaseId: id
    }),
    request
  );
}

export function remove(contractId, id) {
  return axios.delete(
    api.path("contractCustomerDatabase.delete", {
      contractId: contractId,
      customerDatabaseId: id
    })
  );
}

export function list(contractId) {
  return axios.get(
    api.path("contractCustomerDatabase.index", { contractId: contractId })
  );
}

export function show(contractId, id) {
  return axios.get(
    api.path("contractCustomerDatabase.show", {
      contractId: contractId,
      customerDatabaseId: id
    })
  );
}

export function turnOn(contractId, id, request) {
  return axios.put(
    api.path("contractCustomerDatabase.turnOn", {
      contractId: contractId,
      customerDatabaseId: id
    }),
    request
  );
}

export function turnOff(contractId, id, request) {
  return axios.put(
    api.path("contractCustomerDatabase.turnOff", {
      contractId: contractId,
      customerDatabaseId: id
    }),
    request
  );
}
